// extracted by mini-css-extract-plugin
export default {"input_title":"input_input_title__A8R7c","input_input":"input_input_input__td0tS","input_icon":"input_input_icon__aLyQ2","input_error":"input_input_error__b9WvW"};